import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FeatureListRequestBody, FeatureListResponse } from "./types";

export class FeatureListAPI extends BaseAPI<
    FeatureListRequestBody,
    FeatureListResponse
> {
    protected route = ApiRoutes.feature.list;
    protected method = RequestMethod.GET;
}
